import { render, staticRenderFns } from "./Componenti.vue?vue&type=template&id=48fd4e24"
import script from "./Componenti.vue?vue&type=script&lang=js"
export * from "./Componenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports